
let href = window.location.hash.split('?')

var packageName = {
  appName: '进圈',
  company: '厦门鑫达特网络科技有限公司',
  package_name: 'jinquan',
  biz: 'jinquan',
  platform: ''
}
if(href.length > 1) {
  let data = href[1]
  let url = data.split('&')
  for(var item in url) {
    var arr = url[item].split('=')
    packageName[arr[0]] = arr[1]
  }
  switch (packageName.package_name){
    case 'jinquan':
      packageName.appName = '进圈'
      packageName.company = '厦门鑫达特网络科技有限公司'
      break;
    case 'jinquan_leader':
      packageName.appName = '进圈领队版'
      packageName.company = '厦门鑫达特网络科技有限公司'
      break;
    case 'kaituan':
      packageName.appName = '开团'
      packageName.company = '厦门欢众网娱网络科技有限公司'
      break;
    case 'kaituan_leader':
      packageName.appName = '开团领队版'
      packageName.company = '厦门欢众网娱网络科技有限公司'
      break;
    case 'jinquan_jisuban':
      packageName.appName = '进圈极速版'
      packageName.company = '北京漫射网络科技有限公司'
      break;
    case 'qqyy':
      packageName.appName = '圈圈语音'
      packageName.company = '厦门归属网络科技有限公司'
      break;
    case 'maitian':
      packageName.appName = '麦甜'
      packageName.company = packageName.platform === 'ios' ? '北京倾心网络科技有限公司' : '厦门鑫达特网络科技有限公司'
      break;
    case 'maitian_leader':
      packageName.appName = '麦甜领队版'
      packageName.company = packageName.platform === 'ios' ? '北京倾心网络科技有限公司' : '厦门鑫达特网络科技有限公司'
      break;
    // case 'yibo':
    //   packageName.appName = '一波语音'
    //   packageName.company = '厦门欢众网娱网络科技有限公司'
    //   break;
    // case 'yulian':
    //   packageName.appName = '语恋'
    //   packageName.company = '厦门归属网络科技有限公司'
    //   break;
    case 'smeng':
      packageName.appName = '声萌'
      packageName.company = '厦门归属网络科技有限公司'
      break;
    case 'smeng_leader':
      packageName.appName = '声萌领队版'
      packageName.company = '厦门归属网络科技有限公司'
      break;
    case 'smeng_leader2':
      packageName.appName = '声萌领队版'
      packageName.company = '厦门鑫达特网络科技有限公司'
      break;
    case 'shengyu':
      packageName.appName = '声鱼'
      packageName.company = '厦门归属网络科技有限公司'
      break;
    case 'shengyu_leader':
      packageName.appName = '声鱼领队版'
      packageName.company = '厦门归属网络科技有限公司'
      break;
    case 'yuzhilian_leader':
      packageName.appName = '语之恋领队版'
      packageName.company = '厦门鑫达特网络科技有限公司'
      break;
    case 'yibo_leader':
      packageName.appName = '一波语音领队版'
      packageName.company = '厦门鑫达特网络科技有限公司'
      break;
    case 'quanquan_leader':
      packageName.appName = '圈圈语音领队版'
      packageName.company = '厦门鑫达特网络科技有限公司'
      break;
    case 'aiwan':
      packageName.appName = '爱玩'
      packageName.company = '厦门趣聊网络科技有限公司'
      break;
    case 'pairplay':
      packageName.appName = '双人成盒'
      packageName.company = '厦门搭伙网络科技有限公司'
      break;
    case 'syu':
        packageName.appName = '声鱼'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'yayayy':
        packageName.appName = '吖吖语音'
        packageName.company = '厦门趣聊网络科技有限公司'
        break;
    case 'qinmi':
        packageName.appName = '亲觅'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'ouyy':
        packageName.appName = '偶遇吖'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'tayu':
        packageName.appName = '他遇'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'yulian':
        packageName.appName = '语之恋'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'quan':
        packageName.appName = '圈圈语音'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'yibo':
        packageName.appName = '一波语音'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'qingka':
        packageName.appName = '轻卡CP'
        packageName.company = '厦门鑫达特网络科技有限公司'
        break;
    case 'qqyl':
        packageName.appName = '圈圈语聊'
        packageName.company = '厦门鑫达特网络科技有限公司'
  }
}
export default packageName;
